// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__33T-v","text":"SelectPayment_text__3sr_e","title":"SelectPayment_title__1KdoA","btn":"SelectPayment_btn__1K256"};